/**
 * Zentrale Accessibility-Korrekturen fuer alle Slick-Slider im Projekt.
 *
 * 1. Slick setzt in setSlideClasses aria-hidden="true" auf alle nicht sichtbaren
 *    Slides - unabhaengig von der Option "accessibility" - laesst deren Links,
 *    Buttons und Formularfelder aber in der Tab-Reihenfolge. Ergebnis: aria-hidden
 *    mit fokussierbaren Nachfahren (axe aria-hidden-focus, WCAG 4.1.2 / 2.4.3).
 *    inert nimmt den kompletten Teilbaum aus Fokusreihenfolge und Accessibility-Tree,
 *    egal welche Elemente die Redakteure im Slide platzieren.
 *
 * 2. Bei infinite:true klont Slick Slides samt ihrer id-Attribute. Das erzeugt
 *    doppelte IDs im Dokument (ungueltiges HTML). Die IDs im Klon bekommen darum
 *    ein eindeutiges Suffix, die Originale bleiben unveraendert.
 *
 * Der Fix haengt an den Slick-Events. Die bubbeln bis zum document, deshalb greift
 * er fuer jeden Slider im Projekt, ohne dass die einzelnen .slick()-Aufrufstellen
 * angepasst werden muessen.
 */
(function($) {
    'use strict';

    var UPDATE_EVENTS = [
        'init.ttgSlickA11y',
        'reInit.ttgSlickA11y',
        'setPosition.ttgSlickA11y',
        'afterChange.ttgSlickA11y',
        'breakpoint.ttgSlickA11y'
    ].join(' ');

    // Marker an den Slides, die dieses Skript inert gesetzt hat. Damit wird beim
    // Zerstoeren eines Sliders nur das eigene inert entfernt und kein fremdes
    // (z.B. das der NCE-Flipbox auf ihrer abgewandten Kartenseite).
    var INERT_MARKER = 'data-ttg-slick-inert';

    var cloneCounter = 0;

    function setSlideInert(element, inert) {
        if (inert) {
            element.inert = true;
            element.setAttribute('inert', 'inert');
            element.setAttribute(INERT_MARKER, '');
        } else {
            element.inert = false;
            element.removeAttribute('inert');
            element.removeAttribute(INERT_MARKER);
        }
    }

    function focusFallback($slider) {
        var $arrow = $slider.find('.slick-next').first();

        if (!$arrow.length) {
            $arrow = $slider.find('.slick-prev').first();
        }

        if ($arrow.length) {
            $arrow.trigger('focus');
        }
    }

    /**
     * Nur was Slick selbst per aria-hidden als versteckt markiert, wird inert.
     * So bleiben teilweise sichtbare Slides (variableWidth, centerMode) bedienbar
     * und Slider, die aria-hidden bewusst entfernen, bleiben unangetastet.
     */
    function updateSlides($slider) {
        $slider.find('.slick-slide').each(function() {
            var hidden = this.getAttribute('aria-hidden') === 'true';

            if (hidden === (this.hasAttribute(INERT_MARKER))) {
                return;
            }

            if (hidden && this.contains(document.activeElement)) {
                // Fokus retten, bevor der Slide inert wird
                focusFallback($slider);
            }

            setSlideInert(this, hidden);
        });
    }

    function scopeClonedIds($slider) {
        $slider.find('.slick-cloned').each(function() {
            var $clone = $(this);

            if ($clone.data('ttgIdsScoped')) {
                return;
            }

            $clone.data('ttgIdsScoped', true);

            var $withId = $clone.find('[id]').addBack('[id]');

            if (!$withId.length) {
                return;
            }

            var suffix = '-slick-clone-' + (++cloneCounter);

            $withId.each(function() {
                this.id = this.id + suffix;
            });
        });
    }

    function getSlider(event) {
        var element = event.target;

        if (!element || element.nodeType !== 1) {
            return null;
        }

        var $slider = $(element);

        if (!$slider.hasClass('slick-slider') && !$slider.hasClass('slick-initialized')) {
            return null;
        }

        return $slider;
    }

    $(document).on(UPDATE_EVENTS, function(event) {
        var $slider = getSlider(event);

        if (!$slider) {
            return;
        }

        scopeClonedIds($slider);
        updateSlides($slider);
    });

    // Beim Zerstoeren eines Sliders (destroy/unslick) bleibt sonst ein inert stehen,
    // das niemand mehr aufraeumt.
    $(document).on('destroy.ttgSlickA11y unslick.ttgSlickA11y', function(event) {
        if (!event.target || event.target.nodeType !== 1) {
            return;
        }

        $(event.target).find('[' + INERT_MARKER + ']').each(function() {
            setSlideInert(this, false);
        });
    });

    // Slider, die bereits initialisiert waren, bevor dieses Skript geladen wurde
    function sweep() {
        $('.slick-initialized').each(function() {
            var $slider = $(this);

            scopeClonedIds($slider);
            updateSlides($slider);
        });
    }

    $(sweep);
    $(window).on('load', sweep);
}(jQuery));
